/**
 * This is a wrapper for the Material UI Icon Button component to add Google Analytics tracking.
 */

import React, { forwardRef } from 'react';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton'; // eslint-disable-line no-restricted-imports

import { track } from '@common/analytics';

const IconButtonWithAnalytics = forwardRef(
  (
    {
      analytics,
      children,
      disabled,
      loading,
      onClick,
      tooltipProps,
      tooltipTitle,
      'aria-label': ariaLabel,
      ...props
    },
    ref
  ) => {
    const iconButton = (
      <IconButton
        {...props}
        ref={ref}
        disabled={disabled || loading}
        onClick={(...args) => {
          // eslint-disable-next-line no-unused-expressions
          analytics && track(...analytics);
          // eslint-disable-next-line no-unused-expressions
          onClick && onClick(...args);
        }}
        aria-label={ariaLabel ?? tooltipTitle}
      >
        {loading ? <CircularProgress size="1.5rem" thickness={5} /> : children}
      </IconButton>
    );

    return tooltipTitle ? (
      <Tooltip title={tooltipTitle} {...tooltipProps} placement="top">
        <span>{iconButton}</span>
      </Tooltip>
    ) : (
      iconButton
    );
  }
);

export default IconButtonWithAnalytics;
